import { GPT_LANDING_PATH, questionFromHash } from "@juisci/gpt-handoff";
import { memoryStore } from "../../lib/store";

/**
 * `takeHandedQuestion` runs first at boot, before Sentry, Mixpanel and the
 * router read the URL: those record `location.href`, fragment included, and a
 * clinical question is not theirs to keep. It moves the question that the
 * public site handed over (`@juisci/gpt-handoff`) into the in-app hand-off
 * (`initialQuestion` location state), which both landings ask on arrival, and
 * drops the fragment, so a reload or a copied link asks nothing twice.
 */

/**
 * Moves a handed question from the URL into the router state of the current
 * entry. The entry is written in the shape `history` v4 (react-router 5) reads
 * as `location.state`: `{ key, state }`; `questionHandoff.test.ts` pins it
 * against the real library.
 */
export function takeHandedQuestion(): void {
  const { pathname, search, hash } = globalThis.location;
  if (pathname !== GPT_LANDING_PATH) return;
  const question = questionFromHash(hash);
  if (question === null) return;
  handedQuestionArrivedStore.set(true);
  globalThis.history.replaceState(
    {
      key: Math.random().toString(36).slice(2, 8),
      state: { initialQuestion: question },
    },
    "",
    pathname + search
  );
}

/**
 * Whether a question was handed over on this page load. The location state
 * that carries it is consumed once the question is asked, so the fact that it
 * came is kept here for the whole load (`useAnonymousGptFrontDoor`). A memory
 * store: a reload arrives with no question.
 */
export const handedQuestionArrivedStore = memoryStore(false);
